<template>
  <div class="overview">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 轮播图部分 -->
      <section class="banner-section">
        <el-carousel height="538px" :interval="3500" arrow="always">
          <el-carousel-item v-for="(slide, index) in heroSlides" :key="index">
            <div class="banner-slide" :style="{ backgroundImage: `url(${slide.image})` }">
              <div class="banner-overlay">
                <h1 class="banner-title">{{ $t(slide.titleKey) }}</h1>
                <p class="banner-subtitle">{{ $t(slide.descKey) }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>
      <!-- 之于行社会荣誉及奖项 -->
      <section class="honors-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title" style="color:#FF631E"> {{ $t('overview.overText1') }}</h2>
          </div>

          <!-- 荣誉证书展示 -->
          <div class="honors-grid-image">
            <!-- 左上角 - 税务局A级纳税人图片 -->
            <div class="honor-item ">
              <img src="@/assets/images/gailan/图片1.png" alt="税务局A级纳税人证书" class="honor-image">
            </div>

            <!-- 右上角 - 简洁信用等级样式 -->
            <div class="honor-item card-item top-right">
              <div class="simple-card-content">
                <div class="simple-card-left">
                  <span class="simple-grade-letter">A</span>
                </div>

<el-popover
                placement="bottom"
                trigger="hover"  v-show="$t('overview.overText51')">
                      <div  style="width: 48vw;" >
                  {{ $t('overview.overText51') }}<span style="font-weight: bold;"> {{ $t('overview.overText52') }}</span> {{ $t('overview.overText53') }}
                  <span style="font-weight: bold;"> {{ $t('overview.overText54') }}</span>{{ $t('overview.overText55') }}
                </div>
                <div class="simple-card-right" slot="reference">
                  <div class="simple-year">{{ $t('overview.overText2') }}</div>
                  <div class="simple-title">{{ $t('overview.overText3') }}</div>
                </div>
    </el-popover>

                <div class="simple-card-right" v-show="!$t('overview.overText51')">
                  <div class="simple-year"> {{ $t('overview.overText2') }}</div>
                  <div class="simple-title"> {{ $t('overview.overText3') }}</div>
                </div>
              </div>
            </div>

            <!-- 左下角 - 信用等级简洁样式 -->
            <div class="honor-item card-item bottom-left">
              <div class="simple-card-content">
                <div class="simple-card-left">
                  <span class="simple-grade-letter">A</span>
                </div>
<el-popover
                placement="bottom"
                trigger="hover"  v-show="$t('overview.overText31')">
                      <div  style="width: 48vw;" >
                  {{ $t('overview.overText31') }}<span style="font-weight: bold;"> {{ $t('overview.overText32') }}</span> {{ $t('overview.overText33') }}
                  <span style="font-weight: bold;"> {{ $t('overview.overText34') }}</span>{{ $t('overview.overText35') }}
                </div>
                <div class="simple-card-right" slot="reference">
                  <div class="simple-year">{{ $t('overview.overText4') }}</div>
                  <div class="simple-title">{{ $t('overview.overText5') }}</div>
                </div>
    </el-popover>
       <div class="simple-card-right" v-show="!$t('overview.overText31')">
                  <div class="simple-year">{{ $t('overview.overText4') }}</div>
                  <div class="simple-title">{{ $t('overview.overText5') }}</div>
                </div>
              </div>
            </div>

            <!-- 右下角 - 荣誉证书图片 -->
            <div class="honor-item bottom-right">
              <img src="@/assets/images/gailan/图片2.png" alt="知识产权服务证书" class="honor-image">
            </div>
          </div>

          <!-- 全国精准服务保障名单 -->


          <div class="service-guarantee-card">
            <div class="guarantee-header">
              <h3 class="guarantee-title">{{ $t('overview.overText6') }}</h3>
            </div>
            <div class="guarantee-content">
              <div class="company-ranking">
                <div class="company-name">{{ $t('overview.companyLine') }}</div>
                <div class="ranking-info">
                  <span class="batch-info">{{ $t('overview.firstBatch') }}</span>
                  <span class="rank-number">214*</span>
                </div>
              </div>
              
              <el-popover
                placement="bottom"
                trigger="hover"  v-show="$t('overview.rankNote4')">
                <div  style="width: 40vw;" >
                  {{ $t('overview.rankNote4') }}<span style="font-weight: bold;"> {{ $t('overview.rankNote5') }}</span> {{ $t('overview.rankNote6') }}
                  <span style="font-weight: bold;"> {{ $t('overview.rankNote7') }}</span>{{ $t('overview.rankNote8') }}
                </div>
                <div class="ranking-note" slot="reference">
                  {{ $t('overview.rankNote') }}
                  <span style="font-weight: bold;"> {{ $t('overview.rankNote2') }}</span>
                  <span   > {{ $t('overview.rankNote3') }}</span>
                </div>
              </el-popover>
               <div class="ranking-note"  v-show="!$t('overview.rankNote4')">
                  {{ $t('overview.rankNote') }}
                  <span style="font-weight: bold;"> {{ $t('overview.rankNote2') }}</span>
                  <span   > {{ $t('overview.rankNote3') }}</span>
                </div>
            </div>
          </div>
          <!-- 数据见证专业实力区域 -->
          <section class="professional-strength-section">
            <div class="container">
              <div class="strength-header">
                <h2 class="strength-title">{{ $t('overview.strengthTitle') }}</h2>
                <p class="strength-description">
                  {{ $t('overview.strengthDesc') }}
                </p>
              </div>

              <!-- 数据表格展示 -->
              <div class="data-tables-container">
                <!-- 2023年数据表 -->
                <div class="data-table-card">
                  <div class="table-header">
                    <h3 class="table-title">{{ $t('overview.media2023Title') }}</h3>
                  </div>
                  <div class="table-content">
                    <table class="data-table">
                      <thead>
                        <tr>
                          <th>{{ $t('overview.table.agency') }}</th>
                          <th>{{ $t('overview.table.grantRate') }}</th>
                          <th>{{ $t('overview.table.ranking') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="highlight-row">
                          <td class="company-name">{{ $t('overview.companyNameShort') }}</td>
                          <td class="rate-cell">96.7%</td>
                          <td class="rank-cell">5</td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="data-source"><a href="https://mp.weixin.qq.com/s/6iaefNAWqO6bLyXRpgfOFg" target="_blank"
                        rel="noopener" class="source-link" @click="handleSourceClick">{{ $t('overview.sourcePatentTeahouse')
                        }}</a></p>
                  </div>
                </div>

                <!-- 2025年数据表 -->
                <div class="data-table-card">
                  <div class="table-header">
                    <h3 class="table-title">{{ $t('overview.media2025Title') }}</h3>
                  </div>
                  <div class="table-content">
                    <table class="data-table">
                      <thead>
                        <tr>

                          <th>{{ $t('overview.table.agency') }}</th>
                          <th>{{ $t('overview.table.grantRate') }}</th>
                          <!-- <th>{{ $t('overview.table.ranking') }}</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="highlight-row">
                          <td class="company-name">{{ $t('overview.companyNameShort') }}</td>
                          <td class="rate-cell">94.18%</td>
                          <!-- <td class="rank-cell">5</td> -->
                        </tr>
                      </tbody>
                    </table>
                    <p class="data-source"><a href="https://mp.weixin.qq.com/s/4TQvTs1Qx9SGgCMr8elqiQ" target="_blank"
                        rel="noopener" class="source-link" @click="handleSourceClick">{{
                          $t('overview.sourceQianzhi') }}</a></p>
                  </div>
                </div>
              </div>

              <!-- 荣誉成就列表 -->
              <div class="achievements-container">
                <div class="achievements-column">
                  <ul class="achievements-list">
                    <span style="font-weight: bold;">{{ $t('overview.achievements.y2021title') }}</span>
                    <li>{{ $t('overview.achievements.y2021') }}</li>
                    <li>{{ $t('overview.achievements.y2022a') }}</li>
                    <li>{{ $t('overview.achievements.y2022b') }}</li>
                    <li>{{ $t('overview.achievements.y2023a') }}</li>
                    <li>{{ $t('overview.achievements.y2023b') }}</li>
                    <li>{{ $t('overview.achievements.y2024a') }}</li>
                    <li>{{ $t('overview.achievements.y2024b') }}</li>
                  </ul>
                </div>
                <div class="achievements-column">
                  <ul class="achievements-list">
                    <span style="font-weight: bold;">{{ $t('overview.achievements.y2023ctitle') }}</span>
                    <li>{{ $t('overview.achievements.y2023c') }}</li>
                    <li><span class="highlight-blue">{{ $t('overview.achievements.y2025a') }}</span></li>
                    <li><span class="highlight-blue">{{ $t('overview.achievements.y2025b') }}</span></li>
                    <li><span class="highlight-blue">{{ $t('overview.achievements.y2025c') }}</span></li>
                    <li><span class="highlight-blue">{{ $t('overview.achievements.y2025d') }}</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </section>


        </div>
      </section>
      <OverviewShowcaseGroup />

    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import OverviewShowcaseGroup from '@/components/OverviewShowcaseGroup'
export default {
  name: 'Overview',
  components: {
    Header, OverviewShowcaseGroup,
    Footer
  },
  data() {
    return {
      // 无效诉讼图片
      invalidImage01: require('@/assets/images/gailan/susong1.png'),
      invalidImage021: require('@/assets/images/gailan/susong2.png'),
      invalidImage022: require('@/assets/images/gailan/susong3.png'),
      invalidImage03: require('@/assets/images/gailan/susong4.png'),
      invalidImage1: require('@/assets/images/homepageimg/无效专利图1.png'),
      invalidImage2: require('@/assets/images/homepageimg/无效专利图2.png'),
      invalidImage3: require('@/assets/images/homepageimg/无效专利图3.png'),
      zhuanlibookimg: require('@/assets/images/homepageimg/德汉教材.png'),
      renzhengtacimg: require('@/assets/images/homepageimg/tacimg.png'),
      // 案例展示数据
      showcaseItems: [
        {
          title: 'overview.anli101',
          desc: 'overview.anli102',
          image: require('@/assets/images/homepageimg/创意1.1.png')
        },
        {
          title: 'overview.anli201',
          desc: 'overview.anli202',
          image: require('@/assets/images/homepageimg/创意1.2.png')
        },
        {
          title: 'overview.anli301',
          desc: 'overview.anli302',
          image: require('@/assets/images/homepageimg/创意1.3.png')
        }
      ],
      showcase22Items: [
        {
          title: 'overview.anli101',
          desc: 'overview.anli102',
          image: require('@/assets/images/homepageimg/创意3.1.png')
        },
        {
          title: 'overview.anli201',
          desc: 'overview.anli202',
          image: require('@/assets/images/homepageimg/创意3.2.png')
        },
        {
          title: 'overview.anli301',
          desc: 'overview.anli302',
          image: require('@/assets/images/homepageimg/创意3.3.png')
        }
      ],
      // 案例展示数据
      showcase2Items: [
        {
          title: 'overview.anli101',
          desc: 'overview.anli102',
          image: require('@/assets/images/homepageimg/创意2.1.png')
        },
        {
          title: 'overview.anli201',
          desc: 'overview.anli202',
          image: require('@/assets/images/homepageimg/创意2.2.png')
        },
        {
          title: 'overview.anli301',
          desc: 'overview.anli302',
          image: require('@/assets/images/homepageimg/创意2.3.png')
        }
      ],
      anliNum: 1,


      // 案例展示数据
      showcase3Items: [
        {
          title: '原文',
          desc: '',
          image: require('@/assets/images/homepageimg/1h原文.png')
        },
        {
          title: '原译文',
          desc: '',
          image: require('@/assets/images/homepageimg/2h原译文.png')
        },
        {
          title: '建议译文',
          desc: '',
          image: require('@/assets/images/homepageimg/3h建议译文.png')
        }
      ],
      showcase33Items: [
        {
          title: '原文',
          desc: '',
          image: require('@/assets/images/homepageimg/fanyi1原文.png')
        },
        {
          title: '原译文',
          desc: '',
          image: require('@/assets/images/homepageimg/fanyi2原译文.png')
        },
        {
          title: '建议译文',
          desc: '',
          image: require('@/assets/images/homepageimg/fanyi3建议译文.png')
        }
      ],
      heroSlides: [
        {
          titleKey: 'overview.hero.title',
          descKey: 'overview.hero.subtitle',
          image: require('@/assets/images/homepageimg/gailanimg.png')
        }
      ],
      advantages: [
        {
          icon: 'el-icon-user-solid',
          title: '专业团队',
          description: '汇聚海归留学人员及国内知名高校优秀毕业生，专业背景深厚'
        },
        {
          icon: 'el-icon-globe',
          title: '国际视野',
          description: '长期服务中美欧一流企业，具备丰富的国际化服务经验'
        },
        {
          icon: 'el-icon-medal-1',
          title: '权威资质',
          description: '经国家知识产权局批准，具有专利和商标代理资格'
        },
        {
          icon: 'el-icon-s-cooperation',
          title: '全方位服务',
          description: '从申请到维权，提供一站式知识产权保护解决方案'
        }
      ],
      services: [
        {
          title: '专利服务',
          image: require('@/assets/images/s_zhuanli.png'),
          items: ['专利挖掘服务', '专利申请服务', '审查及复审服务', '专利维权服务']
        },
        {
          title: '商标及著作权',
          image: require('@/assets/images/s_shangbiao.png'),
          items: ['商标申请服务', '答辩及近似检索', '集成电路布图设计', '著作权登记']
        },
        {
          title: '商业秘密',
          image: require('@/assets/images/s_shangye.png'),
          items: ['基于销售额的分级策略', '基于技术难度的分级策略', '商业秘密保护', '风险评估']
        },
        {
          title: '侵权维权',
          image: require('@/assets/images/s_qinquan.png'),
          items: ['侵权应对', '被控侵权应对', '保护范围分析', '权利稳定性分析']
        }
      ],
      dialogVisible: false,
    }
  },
  methods: {
    goToContact(num) {
      this.anliNum = num
      this.dialogVisible = true;
    },
    handleSourceClick() {
      // 可接入埋点或日志 https://mp.weixin.qq.com/s/nAxRISd2RaKs4uQQZxkR5g
      console.log('用户点击了千知榜链接');
    },
  }
}
</script>

<style scoped>
/* 瑞士欧瑞康案例样式 */
.oerlikon-case-section {
  margin: 0px 0;
  padding: 40px 20px 50px 20px;
  background: #f8f9fa;
}

.case-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* 公司介绍部分 */
.company-intro {
  padding: 40px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.company-header {
  display: flex;
  align-items: flex-start;
  gap: 30px;
  margin-bottom: 30px;
}

.company-logo {
  flex-shrink: 0;
}

.logo-img {
  width: 200px;
  height: auto;
  padding-top: 0.6rem;
}

.company-description {
  flex: 1;
}

.intro-text {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 20px;
  text-align: justify;
}

.company-name {
  font-weight: bold;
  color: #e74c3c;
  font-size: 18px;
}

.highlight {
  color: #e74c3c;
  font-weight: bold;
  font-size: 18px;
}

.highlight-orange {
  color: #FF631E;
  font-weight: bold;
}

.cooperation-text {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  background: linear-gradient(90deg, #fff3cd, #ffffff);
  padding: 15px 20px;
  border-left: 4px solid #f39c12;
  border-radius: 8px;
  margin-top: 20px;
}

.cooperation-details {
  margin-top: 30px;
}

.details-text,
.service-text {
  font-size: 15px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 20px;
  text-align: justify;
  padding: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

/* 专利表格部分 */
.patent-table-section {
  padding: 40px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.table-title-zl {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 30px;
  position: relative;
}

.table-title-zl::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  border-radius: 2px;
}

.table-wrapper {
  overflow-x: auto;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.patent-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 14px;
}

.patent-table thead {
  background: linear-gradient(135deg, #FF631E 0%, #e55a1a 100%);
  color: white;
}

.patent-table th {
  padding: 18px 15px;
  text-align: center;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.5px;
}

.patent-table td {
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.patent-table tbody tr {
  transition: all 0.3s ease;
}

.patent-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.patent-table tbody tr:hover {
  background-color: #e3f2fd;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.col-no {
  width: 8%;
  background: linear-gradient(135deg, #ff8c42 0%, #FF631E 100%) !important;
}

.col-title {
  width: 50%;
  text-align: left !important;
}

.col-application {
  width: 22%;
  background: linear-gradient(135deg, #ff8c42 0%, #FF631E 100%) !important;
}

.col-status {
  width: 20%;
  background: linear-gradient(135deg, #ff8c42 0%, #FF631E 100%) !important;
}

.patent-table td.col-title {
  text-align: left;
  font-weight: 500;
}

.status-granted {
  background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.5px;
  box-shadow: 0 3px 10px rgba(39, 174, 96, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .company-header {
    flex-direction: column;
    text-align: center;
  }

  .logo-img {
    width: 150px;
  }

  .intro-text,
  .cooperation-text,
  .details-text,
  .service-text {
    font-size: 14px;
  }

  .patent-table {
    font-size: 12px;
  }

  .patent-table th,
  .patent-table td {
    padding: 10px 8px;
  }

  .table-title-zl {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .oerlikon-case-section {
    padding: 0 10px;
  }

  .company-intro,
  .patent-table-section {
    padding: 20px;
  }

  .patent-table th,
  .patent-table td {
    padding: 8px 5px;
  }

  .status-granted {
    padding: 6px 12px;
    font-size: 10px;
  }
}

.overview {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 100vh;
}

/* 轮播图样式 */
.banner-section {
  position: relative;
  width: 100%;
  height: 538px;
  overflow: hidden;
}

.banner-slide {
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 0 20px;
}

.banner-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.banner-subtitle {
  font-size: 1.5rem;
  margin: 0 0 30px;
  max-width: 800px;
  line-height: 1.5;
}

/* 自定义轮播图样式 */
.el-carousel__item {
  height: 100%;
}

/* 英雄区域 */
.hero-section {
  position: relative;
  height: 100vh;
  min-height: 600px;
  background: linear-gradient(135deg, #FF631E 0%, #FF8A50 100%);
  display: flex;
  align-items: center;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-logo {
  width: 400px;
  height: auto;
  opacity: 0.3;
}

.hero-overlay {
  position: relative;
  z-index: 2;
  width: 100%;
}

.hero-content {
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.8rem;
  font-weight: 300;
  margin-bottom: 1.5rem;
  opacity: 0.9;
}

.hero-description {
  font-size: 1.2rem;
  margin-bottom: 3rem;
  opacity: 0.8;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero-stats {
  display: flex;
  justify-content: center;
  gap: 4rem;
  margin-top: 3rem;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1rem;
  opacity: 0.8;
}

/* 通用样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 核心优势 */
.advantages-section {
  padding: 6rem 0;
  background-color: #f8f9fa;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.advantage-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FF631E, #FF8A50);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.advantage-icon i {
  font-size: 2rem;
  color: white;
}

.advantage-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.advantage-description {
  color: #666;
  line-height: 1.6;
}

/* 服务领域 */
.services-section {
  padding: 6rem 0;
  background: white;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.service-card {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.service-image {
  height: 200px;
  overflow: hidden;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.service-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.service-content {
  padding: 2rem;
}

.service-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #FF631E;
}

.service-list {
  list-style: none;
  padding: 0;
}

.service-list li {
  padding: 0.5rem 0;
  color: #666;
  position: relative;
  padding-left: 1.5rem;
}

.service-list li::before {
  content: '•';
  color: #FF631E;
  position: absolute;
  left: 0;
  font-weight: bold;
}

/* 团队实力 */
.team-strength-section {
  padding: 6rem 0;
  background: linear-gradient(135deg, #FFF5F0 0%, #FFE8D6 100%);
}

.team-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.highlight-item {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.highlight-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #FF631E, #FF8A50);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.highlight-icon i {
  font-size: 1.5rem;
  color: white;
}

.highlight-content h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}

.highlight-content p {
  color: #666;
  line-height: 1.5;
  margin: 0;
}

/* 客户服务 */
.clients-section {
  padding: 6rem 0;
  background: white;
}

.clients-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.client-highlight {
  margin-bottom: 2rem;
}

.client-highlight h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #FF631E;
  margin-bottom: 1rem;
}

.client-highlight p {
  color: #666;
  line-height: 1.6;
}

.clients-visual {
  position: relative;
  height: 400px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.world-map {
  position: relative;
  width: 300px;
  height: 200px;
}

.map-point {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.point {
  width: 12px;
  height: 12px;
  background: #FF631E;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  animation: pulse 2s infinite;
}

.point-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.china {
  top: 30%;
  right: 20%;
}

.usa {
  top: 40%;
  left: 10%;
}

.europe {
  top: 20%;
  left: 40%;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 99, 30, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(255, 99, 30, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 99, 30, 0);
  }
}

/* CTA 区域 */
.cta-section {
  padding: 6rem 0;
  background: linear-gradient(135deg, #FF631E 0%, #FF8A50 100%);
  color: white;
}

.cta-content {
  text-align: center;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.cta-description {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}



/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-stats {
    gap: 2rem;
  }

  .clients-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
  }

  .hero-stats {
    flex-direction: column;
    gap: 1rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .advantages-grid,
  .services-grid,
  .team-highlights {
    grid-template-columns: 1fr;
  }

  .highlight-item {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .container {
    padding: 0 1rem;
  }

  .hero-section {
    height: 80vh;
  }

  .hero-title {
    font-size: 1.8rem;
  }

  .advantage-card,
  .service-content,
  .highlight-item {
    padding: 1.5rem;
  }
}

/* 荣誉展示区域样式 */
.honors-section {
  padding: 3.5rem 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.honors-section .section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.honors-section .section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1rem;
}

.honors-section .section-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

.honors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

/* 新的图片+文字混合网格布局 */
.honors-grid-image {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
  height: 350px;
}

.honor-item {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.honor-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}


.honor-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
  padding: 2rem;
  text-align: center;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}


.image-overlay h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.image-overlay p {
  font-size: 1rem;
  opacity: 0.9;
}

/* 卡片样式项 */
.card-item {
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
}

.card-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 右上角和左下角共用简洁样式 */
.top-right,
.bottom-left {
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 100%);
  border: 2px solid #E3F2FD;
}

/* 左下角简洁信用等级样式 */
.bottom-left {
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 100%);
  border: 2px solid #E3F2FD;
}

.simple-card-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0;
}

.simple-card-left {
  flex: 0 0 35%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.simple-grade-letter {
  font-size: 5rem;
  font-weight: bold;
  color: #FF4444;
  line-height: 1;
}

.simple-card-right {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 1.5rem;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 100%);
}

.simple-year {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.simple-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
}

/* 卡片阴影和边框效果 */
.card-item::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.5) 50%, transparent 70%);
  border-radius: 14px;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.card-item:hover::before {
  opacity: 1;
}

/* 模拟纸质质感 */
.card-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 99, 30, 0.03) 0%, transparent 50%);
  border-radius: 12px;
  pointer-events: none;
}




/* 当图片加载成功时隐藏占位符 */
.honor-image[src]:not([src=""])~.image-item::before,
.image-item:has(.honor-image[src]:not([src=""])) ::before {
  display: none;
}

.honor-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
}

.honor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

/* 税务局荣誉卡片 */
.tax-honor {
  border-left: 4px solid #4CAF50;
}

.tax-honor .honor-header {
  margin-bottom: 1.5rem;
}

.gov-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #E8F5E8;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #2E7D32;
  font-weight: 600;
}

.location-tag {
  background: #4CAF50;
  color: white;
  padding: 0.2rem 0.8rem;
  border-radius: 12px;
  font-size: 0.8rem;
  margin-left: auto;
}

.company-info h3 {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.company-code {
  font-size: 0.9rem;
  color: #666;
  font-family: 'Courier New', monospace;
}

.grade-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.grade-a .grade-letter {
  width: 40px;
  height: 40px;
  background: #4CAF50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.grade-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

/* 信用等级卡片 */
.credit-honor {
  background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
  color: white;
  text-align: center;
}

.honor-content-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.year-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 600;
}

.grade-display {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.grade-letter-large {
  font-size: 4rem;
  font-weight: bold;
  line-height: 1;
}

.grade-text-large {
  font-size: 1.3rem;
  font-weight: 600;
  margin-top: 0.5rem;
}

/* 知识产权局荣誉卡片 */
.ip-honor {
  border-left: 4px solid #2196F3;
}

.ip-badge {
  background: #E3F2FD;
  color: #1976D2;
}

.credit-tag {
  background: #2196F3;
  color: white;
  padding: 0.2rem 0.8rem;
  border-radius: 12px;
  font-size: 0.8rem;
  margin-left: auto;
}

.service-info p {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.service-info h3 {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.agency-code {
  font-size: 0.9rem;
  color: #666;
  font-family: 'Courier New', monospace;
}

.grade-a-blue .grade-letter {
  width: 40px;
  height: 40px;
  background: #2196F3;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
}

/* 全国精准服务保障名单卡片 */
.service-guarantee-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 3rem;
}

.guarantee-header {
  background: linear-gradient(135deg, #FF631E 0%, #FF8A50 100%);
  color: white;
  padding: 1.5rem 2rem;
  text-align: center;
}

.guarantee-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.guarantee-content {
  padding: 2rem;
}

.company-ranking {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.company-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

.ranking-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.batch-info {
  background: #FF631E;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
}

.rank-number {
  font-size: 1.5rem;
  font-weight: bold;
  color: #FF631E;
}

.ranking-note {
  font-size: 0.8rem;
  color: #666;
  text-align: center;
  font-style: italic;
}

/* 统计数据行 */
.stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-3px);
}

.stat-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #FF631E, #FF8A50);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.2rem;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
}

/* 荣誉区域响应式设计 */
@media (max-width: 992px) {
  .honors-grid {
    grid-template-columns: 1fr;
  }

  .honors-grid-image {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 250px);
    height: auto;
  }

  .company-ranking {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .honors-grid-image {
    gap: 1rem;
    grid-template-rows: repeat(4, 200px);
  }

  .card-item {
    padding: 0;
  }



  .simple-grade-letter {
    font-size: 3.5rem;
  }

  .simple-card-right {
    padding: 1.5rem 1rem;
  }

  .simple-year {
    font-size: 1.1rem;
  }

  .simple-title {
    font-size: 1.1rem;
  }

  .image-overlay {
    padding: 1.5rem;
  }
}

@media (max-width: 576px) {
  .honors-section {
    padding: 4rem 0;
  }

  .honors-grid-image {
    grid-template-rows: repeat(4, 180px);
    gap: 1rem;
  }

  .honor-card {
    padding: 1.5rem;
  }

  .card-item {
    padding: 0;
  }



  .simple-card-content {
    flex-direction: column;
  }

  .simple-card-left {
    flex: 0 0 50%;
    width: 100%;
  }

  .simple-grade-letter {
    font-size: 2.5rem;
  }

  .simple-card-right {
    flex: 1;
    width: 100%;
    padding: 1rem;
    text-align: center;
  }

  .simple-year {
    font-size: 1rem;
  }

  .simple-title {
    font-size: 1rem;
  }

  .image-overlay h3 {
    font-size: 1.1rem;
  }

  .image-overlay p {
    font-size: 0.9rem;
  }

  .guarantee-header {
    padding: 1rem;
  }

  .guarantee-content {
    padding: 1.5rem;
  }

  .stats-row {
    grid-template-columns: 1fr;
  }

  .stat-item {
    padding: 1rem;
  }
}

/* 专业实力展示区域样式 */
.professional-strength-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
}

.professional-strength-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="%23e2e8f0" stroke-width="0.5" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
  pointer-events: none;
}

.strength-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.strength-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  position: relative;
}

.strength-title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
}

.strength-description {
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
  text-align: justify;
}

/* 数据表格容器 */
.data-tables-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.data-table-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.data-table-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.table-header {
  background: linear-gradient(135deg, #FF631E 0%, #e55a1a 100%);
  padding: 1.2rem 1.5rem;
  color: white;
}

.table-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.highlight {
  color: #2C3E50;
  font-weight: 700;
}

.table-content {
  padding: 1.5rem;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.data-table th {
  background: linear-gradient(135deg, #ff8c42 0%, #FF631E 100%);
  color: white;
  padding: 0.8rem 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.9rem;
  border: 1px solid #FF631E;
}

.data-table td {
  padding: 1rem;
  text-align: center;
  border: 1px solid #e2e8f0;
  font-size: 0.95rem;
}

.highlight-row {
  background: linear-gradient(135deg, #fff5e6 0%, #ffe4cc 100%);
}

.company-name {
  font-weight: 600;
  color: #2d3748;
  text-align: left !important;
}

.rate-cell {
  font-weight: 700;
  color: #FF631E;
  font-size: 1.1rem;
}

.rank-cell {
  font-weight: 700;
  color: #FF631E;
  font-size: 1.1rem;
}

.data-source {
  font-size: 0.8rem;
  color: #718096;
  text-align: right;
  margin: 0;
  font-style: italic;
}

.source-link {
  color: #FF631E;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 1px solid transparent;
  transition: color .2s ease, border-color .2s ease;
}

.source-link:hover {
  color: #e55a1a;
  border-bottom-color: #FF631E;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .source-link {
    padding: 2px 4px;
    border-radius: 3px;
    background: rgba(255, 99, 30, 0.08);
  }

  .source-link:hover {
    background: rgba(255, 99, 30, 0.15);
  }
}

/* 荣誉成就列表 */
.achievements-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  position: relative;
  z-index: 1;
}

.achievements-column {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

.achievements-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.achievements-list li {
  padding: 0.8rem 0;
  border-bottom: 1px solid #f7fafc;
  color: #4a5568;
  line-height: 1.6;
  position: relative;
  padding-left: 1.5rem;
}

.achievements-list li:last-child {
  border-bottom: none;
}

.achievements-list li::before {
  content: '•';
  color: #FF631E;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 0.8rem;
}

.highlight-blue {
  color: #FF631E;
  font-weight: 600;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .data-tables-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .achievements-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .strength-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .professional-strength-section {
    padding: 3rem 0;
  }

  .strength-title {
    font-size: 1.5rem;
    line-height: 1.4;
  }

  .strength-description {
    font-size: 1rem;
    padding: 0 1rem;
  }

  .table-content {
    padding: 1rem;
  }

  .data-table th,
  .data-table td {
    padding: 0.6rem 0.5rem;
    font-size: 0.8rem;
  }

  .company-name {
    font-size: 0.75rem;
  }

  .achievements-column {
    padding: 1.5rem;
  }

  .achievements-list li {
    font-size: 0.9rem;
    padding: 0.6rem 0;
    padding-left: 1.2rem;
  }
}

@media (max-width: 480px) {
  .strength-title {
    font-size: 1.3rem;
  }

  .table-title {
    font-size: 1rem;
  }

  .data-table th,
  .data-table td {
    padding: 0.5rem 0.3rem;
    font-size: 0.75rem;
  }

  .company-name {
    font-size: 0.7rem;
  }

  .achievements-list li {
    font-size: 0.85rem;
  }
}

/* 成功案例展示区域样式 */
.success-case-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
}

.success-case-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.case-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.4;
  position: relative;
  display: inline-block;
}

.case-title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  border-radius: 2px;
}

.case-layout {
  display: flex;
  gap: 3rem;
  align-items: flex-start;
}

/* 左侧图片区域 - 40% */
.case-images {
  flex: 0 0 29%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  height: 33rem;
}

.image-top {
  /* flex: 0 0 20%; */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-bottom {
  /* flex: 0 0 65%; */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-top:hover,
.image-bottom:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.case-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 右侧文字区域 - 60% */
.case-content {
  flex: 0 0 72%;
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

.case-text p {
  font-size: 1.3rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 1.5rem;
  text-align: justify;
}

.case-text p:last-child {
  margin-bottom: 0;
}

.case-text strong {
  color: #FF631E;
  font-weight: 600;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .case-layout {
    flex-direction: column;
    gap: 2rem;
  }

  .case-images {
    flex: none;
    width: 100%;
    flex-direction: row;
    gap: 1rem;
  }

  .image-top {
    flex: 0 0 30%;
  }

  .image-bottom {
    flex: 0 0 70%;
  }

  .case-content {
    flex: none;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .success-case-section {
    padding: 3rem 0;
  }

  .case-images {
    flex-direction: column;
    gap: 1rem;
  }

  .image-top,
  .image-bottom {
    flex: none;
    height: 200px;
  }

  .case-content {
    padding: 2rem;
  }

  .case-text p {
    font-size: 0.95rem;
    line-height: 1.7;
  }
}

@media (max-width: 480px) {
  .case-content {
    padding: 1.5rem;
  }

  .case-text p {
    font-size: 0.9rem;
    margin-bottom: 1.2rem;
  }

  .image-top,
  .image-bottom {
    height: 150px;
  }
}

/* showcase-row, showcase-card, etc. are needed */
.showcase-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
}

.showcase-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 0 0 280px;
}

.showcase-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
}

.showcase-image {
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.showcase-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.showcase-content {
  padding: 1.5rem;
}

.showcase-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.8rem;
}

.showcase-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.showcase-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.arrow-icon {
  font-size: 2.4rem;
  color: #FF631E;
  font-weight: bold;
  font-style: normal;
}


.showcase-cta {
  text-align: center;
  /* margin-bottom: 2rem; */
}

.cta-button {
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.4);
}

/* 专利校对服务部分 */
.patent-proofreading-section {
  padding: 1rem 0;
  background: #f8f9fa;
}

.patent-proofreading-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.patent-proofreading-section .main-title {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.patent-proofreading-section .main-desc {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.slogan-section {
  text-align: center;
  margin-bottom: 3rem;
}

.slogan {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.slogan-desc {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}

.service-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
}

.service-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.card-icon {
  width: 90px;
  height: 90px;
  background: #333;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  flex-shrink: 0;
}

.card-content p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

.book-showcase {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.book-image {
  flex: 0 0 200px;
}

.book-image img {
  width: 100%;
  border-radius: 8px;
}

.book-description p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  text-align: justify;
}

@media (max-width: 992px) {
  .showcase-row {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 400px;
  }

  .showcase-arrow {
    transform: rotate(90deg);
    height: 40px;
  }

  .arrow-icon {
    font-size: 1.5rem;
  }

  .service-cards {
    grid-template-columns: 1fr;
  }

  .patent-proofreading-section .main-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .showcase-image {
    height: 160px;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 320px;
  }

  .cta-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }

  .patent-proofreading-section {
    padding: 3rem 0;
  }

  .service-card {
    padding: 1.5rem;
  }

  .book-showcase {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .book-image {
    flex: none;
    align-self: center;
  }

  .book-image img {
    max-width: 200px;
    width: auto;
  }

  .book-description {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .showcase-card {
    max-width: 280px;
  }

  .showcase-image {
    height: 140px;
  }

  .showcase-content {
    padding: 1rem;
  }

  .showcase-title {
    font-size: 1rem;
  }

  .showcase-desc {
    font-size: 0.85rem;
  }

  /* Book showcase 手机端优化 */
  .book-showcase {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    margin-bottom: 2rem;
  }

  .book-image {
    flex: none;
    align-self: center;
  }

  .book-image img {
    max-width: 150px;
    width: auto;
  }

  .book-description {
    text-align: left;
  }

  .book-description p {
    font-size: 0.9rem;
    line-height: 1.6;
  }
}

/* 弹窗样式 */
.contact-dialog .el-dialog__header {
  display: none;
}

.contact-dialog .el-dialog__body {
  padding: 0;
  border-radius: 15px;
}

.dialog-content {
  padding: 2rem 2.5rem;
  background: #f8f9fa;
}

.dialog-header {
  text-align: center;
  margin-bottom: 2rem;
}

.dialog-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.dialog-subtitle {
  font-size: 1rem;
  color: #666;
}

.dialog-body {
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
}

.dialog-body .image-gallery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 0 0 420px;
}

.gallery-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  text-align: left;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.gallery-item img {
  width: 18.75rem;
  /* 300px */
  border-radius: 8px;
  flex-shrink: 0;
}

.gallery-image {
  height: 9.375rem;
  /* 150px */
  object-fit: contain;
}

.gallery-item .item-caption {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.dialog-body .text-content {
  flex: 1;
  min-width: 0;
  text-align: justify;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #555;
}

.dialog-body .text-content p {
  margin-bottom: 1rem;
}

.dialog-footer {
  text-align: center;
  margin-top: 0rem;
}

.home-page {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}



.banner-slide {
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 0 20px;
}

.banner-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.banner-subtitle {
  font-size: 1.5rem;
  margin: 0 0 30px;
  max-width: 800px;
  line-height: 1.5;
}

/* 自定义轮播图样式 */
.el-carousel__item {
  height: 100%;
}

/* 通用部分样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0rem 0;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
}

.section-text {
  font-size: 1.1rem;
  line-height: 1.6;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  color: #666;
}

/* 简介部分样式 */
.intro-section {
  background-color: #f8f9fa;
  padding: 4rem 0;
}

.intro-content {
  text-align: center;
}

/* 公司介绍 */
.about-section {
  background: #FFF5F0;
  padding: 4rem 0;
}

.section-title.accent {
  color: #FF631E;
  font-size: 1.8rem;
}

.about-card {
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  background: #fff;
  border-radius: 12px;
  padding: 2rem 2rem 0.5rem 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.about-content p {
  font-size: 0.98rem;
  line-height: 1.9;
  color: #333;
  margin-bottom: 1rem;
  text-align: justify;
}

.about-side .metrics {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-bottom: 1.2rem;
}

.metric {
  background: #fff7f3;
  border: 1px solid #ffe3d6;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.metric .num {
  font-size: 1.6rem;
  color: #FF631E;
  font-weight: 700;
}

.metric .txt {
  color: #666;
}

.about-cta .el-button--primary {
  background: #FF631E;
  border-color: #FF631E;
}

/* 创意天地 */
.creative-section {
  padding: 2rem 0;
  background-image: url('~@/assets/images/homepageimg/创意天地.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
}

.creative-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.creative-section .container {
  position: relative;
}

.creative-section .section-title,
.creative-section .section-sub {
  color: #fff;
}

.section-head {
  text-align: center;
  margin-bottom: 1.5rem;
}

.section-sub {
  color: #666;
  font-size: 0.95rem;
}

.creative-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.creative-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: transform .25s ease, box-shadow .25s ease;
}

.creative-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.1);
}

.creative-card .cover {
  height: 180px;
  background-size: cover;
  background-position: center;
}

.creative-card .body {
  padding: 1rem 1.1rem 1.2rem;
}

.creative-card .title {
  font-size: 1.1rem;
  margin-bottom: .5rem;
  color: #333;
}

.creative-card .desc {
  color: #666;
  font-size: .95rem;
  line-height: 1.6;
}

/* 案例展示部分 */
.showcase-section {
  padding: 0rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.showcase-section .section-head {
  text-align: center;
  margin-bottom: 3rem;
}

.showcase-section .section-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.showcase-section .section-sub {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.showcase-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
}

.showcase-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 0 0 280px;
}

.showcase-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
}

.showcase-image {
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.showcase-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.showcase-content {
  padding: 1.5rem;
}

.showcase-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.8rem;
}

.showcase-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.showcase-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.arrow-icon {
  font-size: 2.4rem;
  color: #FF631E;
  font-weight: bold;
  font-style: normal;
}


.showcase-cta {
  text-align: center;
  /* margin-bottom: 2rem; */
}

.cta-button {
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.4);
}

/* 响应式设计 */
@media (max-width: 992px) {
  .showcase-row {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 400px;
  }

  .showcase-arrow {
    transform: rotate(90deg);
    height: 40px;
  }

  .arrow-icon {
    font-size: 1.5rem;
  }

  .showcase-section .section-title {
    font-size: 1.75rem;
  }
}

@media (max-width: 768px) {
  .showcase-section {
    padding: 3rem 0;
  }

  .showcase-image {
    height: 160px;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 320px;
  }

  .cta-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }

  .dialog-body {
    flex-direction: column;
    gap: 1.5rem;
  }

  .dialog-body .image-gallery {
    flex: none;
    width: 100%;
  }

  .dialog-body .text-content {
    flex: none;
    width: 100%;
  }

  .gallery-item {
    flex-direction: column;
    text-align: center;
    padding: 0.75rem;
  }

  .gallery-item img {
    width: 100%;
    max-width: 250px;
  }

  .gallery-image {
    height: 100px;
  }

  .gallery-item .item-caption {
    margin-top: 0.75rem;
    margin-left: 0;
    font-size: 0.9rem;
  }
}

/* 专利校对服务部分 */
.patent-proofreading-section {
  padding: 1rem 0;
  background: #f8f9fa;
}

.patent-proofreading-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.patent-proofreading-section .main-title {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.patent-proofreading-section .main-desc {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.slogan-section {
  text-align: center;
  margin-bottom: 3rem;
}

.slogan {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.slogan-desc {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}

.service-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
}

.service-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.card-icon {
  width: 90px;
  height: 90px;
  background: #333;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  flex-shrink: 0;
}

.card-content p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

.showcase-demo {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.showcase-demo img {
  flex: 1;
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
}

.demo-image {
  border-radius: 12px;
  overflow: hidden;
}

.image-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
  height: 300px;
}

.image-grid img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.demo-content {
  display: flex;
  align-items: center;
}

.patent-document {
  width: 100%;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.doc-header {
  background: #f5f5f5;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.doc-title {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

.doc-content {
  padding: 1rem;
}

.doc-line {
  font-size: 0.85rem;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  color: #333;
}

.doc-line.highlight {
  background: rgba(255, 99, 30, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  color: #FF631E;
  font-weight: 500;
}

.book-showcase {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.book-image {
  flex: 0 0 200px;
}

.book-image img {
  width: 100%;
  border-radius: 8px;
}

.book-description p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  text-align: justify;
}

/* 专利校对响应式 */
@media (max-width: 992px) {
  .service-cards {
    grid-template-columns: 1fr;
  }

  .showcase-demo {
    flex-direction: column;
  }

  .showcase-demo img {
    height: 200px;
  }

  .patent-proofreading-section .main-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .patent-proofreading-section {
    padding: 3rem 0;
  }

  .service-card {
    padding: 1.5rem;
  }

  .showcase-demo img {
    height: 150px;
  }

  .book-showcase {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .book-image {
    flex: none;
    align-self: center;
  }

  .book-image img {
    max-width: 200px;
    width: auto;
  }

  .book-description {
    text-align: center;
  }
}

/* 无效诉讼案例部分 */
.invalid-cases-section {
  padding: 1rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.invalid-cases-section .section-header {
  text-align: center;
  margin-bottom: 2rem;
}

.invalid-cases-section .main-title {
  font-size: 2.0rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.invalid-cases-section .main-desc {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.8;

  font-weight: 500;
  /* max-width: 900px; */
  margin: 2rem 0rem 1rem 0rem;
}

.invalid-images {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.invalid-images img {
  flex: 1;
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
}

@media (max-width: 992px) {
  .invalid-images {
    flex-direction: column;
  }

  .invalid-images img {
    height: 200px;
  }

  .invalid-cases-section .main-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .invalid-cases-section {
    padding: 3rem 0;
  }

  .invalid-images img {
    height: 150px;
  }
}

/* 案例分区 */
.cases-section {
  padding: 3.5rem 0 4rem;
  background: #fff;
}

.cases-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.cases-grid.single-column {
  grid-template-columns: 1fr;
  max-width: 600px;
  margin: 0 auto;
}

.column-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .8rem;
}

.column-title {
  font-size: 1.2rem;
  color: #333;
  position: relative;
}

.column-title::after {
  content: '';
  display: block;
  width: 36px;
  height: 3px;
  background: #FF631E;
  margin-top: .4rem;
  border-radius: 3px;
}

.more-btn {
  background: #fff7f3;
  border: 1px solid #ffe3d6;
  color: #FF631E;
  border-radius: 20px;
  padding: .35rem .8rem;
  cursor: pointer;
  transition: all .2s ease;
}

.more-btn:hover {
  background: #FF631E;
  color: #fff;
  border-color: #FF631E;
}

.case-card {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 1rem;
  padding: .9rem;
  border-radius: 10px;
  border: 1px solid #f2f2f2;
  margin-bottom: .9rem;
  transition: box-shadow .2s ease;
}

.case-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.case-card .thumb {
  width: 120px;
  height: 80px;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
}

.case-card .case-title {
  font-size: 1rem;
  color: #333;
  margin-bottom: .35rem;
}

.case-card .case-brief {
  color: #666;
  font-size: .92rem;
  line-height: 1.5;
}

/* 联系部分样式 */
.contact-section {
  background-color: #007bff;
  color: white;
  padding: 4rem 0;
}

.contact-section .section-title {
  color: white;
}

.contact-section .section-text {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
}

.contact-content {
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .about-card {
    grid-template-columns: 1fr;
  }

  .creative-grid,
  .cases-grid {
    grid-template-columns: 1fr;
  }

  .creative-card .cover {
    height: 160px;
  }

  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-title {
    font-size: 4rem;
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }

  .banner-title {
    font-size: 3rem;
  }

  .banner-section {
    height: 400px;
  }
}

@media (max-width: 640px) {

  /* Dialog 平板端优化 */
  .contact-dialog .el-dialog {
    width: 90% !important;
  }

  .dialog-content {
    padding: 2rem 1.5rem;
  }

  .dialog-body {
    flex-direction: column;
    gap: 2rem;
  }

  .dialog-body .image-gallery {
    flex: none;
    width: 100%;
  }

  .dialog-body .text-content {
    flex: none;
    width: 100%;
  }

  .gallery-item {
    flex-direction: row;
    text-align: left;
    padding: 1rem;
  }

  .gallery-item img {
    width: 150px;
    max-width: 150px;
    flex-shrink: 0;
  }

  .gallery-image {
    height: 100px;
  }

  .gallery-item .item-caption {
    margin-top: 0;
    margin-left: 1rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .showcase-card {
    max-width: 280px;
  }

  .showcase-image {
    height: 140px;
  }

  .showcase-content {
    padding: 1rem;
  }

  .showcase-title {
    font-size: 1rem;
  }

  .showcase-desc {
    font-size: 0.85rem;
  }

  /* Dialog 移动端优化 */
  .contact-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }

  .dialog-content {
    padding: 1.5rem 1rem;
  }

  .dialog-title {
    font-size: 1.5rem;
  }

  .dialog-body {
    gap: 1rem;
  }

  .dialog-body .text-content {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .gallery-item {
    padding: 0.5rem;
    margin-bottom: 0.75rem;
  }

  .gallery-item img {
    max-width: 200px;
  }

  .gallery-image {
    height: 80px;
  }

  .gallery-item .item-caption {
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }

  /* Book showcase 手机端优化 */
  .book-showcase {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    margin-bottom: 2rem;
  }

  .book-image {
    flex: none;
    align-self: center;
  }

  .book-image img {
    max-width: 150px;
    width: auto;
  }

  .book-description {
    text-align: left;
  }

  .book-description p {
    font-size: 0.9rem;
    line-height: 1.6;
  }
}

@media (max-width: 576px) {
  .banner-title {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 2rem;
  }
}

/* 高价值专利评估案例区域样式 */
.high-value-patent-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
}

.high-value-patent-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="%23e2e8f0" opacity="0.4"/></pattern></defs><rect width="100" height="100" fill="url(%23dots)"/></svg>');
  pointer-events: none;
}

.high-value-patent-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.patent-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.4;
  position: relative;
  display: inline-block;
}

.patent-title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
}

/* 三张图片均分布局 */
.patent-images-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 2.5rem;
  position: relative;
  z-index: 1;
  height: 33rem;
}

.patent-image-item {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
}

.patent-image-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.patent-image-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.patent-image-item:hover::before {
  opacity: 1;
}

.patent-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.patent-image-item:hover .patent-image {
  transform: scale(1.05);
}

/* 底部文字 */
.patent-footer {
  text-align: center;
  position: relative;
  z-index: 1;
}

.patent-footer-text {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  padding: 1rem 2rem;
  background: white;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  display: inline-block;
  border: 2px solid #FF631E;
  position: relative;
  overflow: hidden;
}

.patent-footer-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 99, 30, 0.1), transparent);
  transition: left 0.5s ease;
}

.patent-footer-text:hover::before {
  left: 100%;
}

/* 高价值专利评估案例响应式设计 */
@media (max-width: 1024px) {
  .patent-images-grid {
    gap: 1.5rem;
  }

  .patent-image {
    height: 250px;
  }

  .patent-title {
    font-size: 1.9rem;
  }
}

@media (max-width: 768px) {
  .high-value-patent-section {
    padding: 3rem 0;
  }

  .patent-images-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    max-width: 400px;
    margin: 0 auto 2.5rem;
  }

  .patent-image {
    height: 200px;
  }

  .patent-title {
    font-size: 1.6rem;
  }

  .patent-footer-text {
    font-size: 1.1rem;
    padding: 0.8rem 1.5rem;
  }

}

@media (max-width: 480px) {
  .patent-images-grid {
    max-width: 320px;
    gap: 1rem;
  }

  .patent-image {
    height: 180px;
  }

  .patent-title {
    font-size: 1.4rem;
  }

  .patent-footer-text {
    font-size: 1rem;
    padding: 0.7rem 1.2rem;
  }
}

@media (max-width: 360px) {
  .patent-images-grid {
    max-width: 280px;
  }

  .patent-image {
    height: 160px;
  }

  .patent-title {
    font-size: 1.2rem;
  }
}
</style>